import { render, staticRenderFns } from "./ArticlesPreImports.vue?vue&type=template&id=531c4590&"
import script from "./ArticlesPreImports.vue?vue&type=script&lang=js&"
export * from "./ArticlesPreImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports